import React from "react";
import {Link} from 'gatsby';
import headerStyles from './header.module.scss';

const Header = () => {
    return (
        <header className={headerStyles.header} id="nav">
            <nav>
                <ul className={headerStyles.navList}>
                    <li><Link to="/" className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem}>Home</Link></li>
                    <li><Link to="/about#nav" className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem}>About</Link></li>
                    <li><Link to="/podcast#nav" className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem}>Podcast</Link></li>
                    <li><Link to="/blog#nav" className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem}>Blog</Link></li>
                    <li><Link to="/contact#nav" className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem}>Contact</Link></li>
                    <li><Link to="/subscribe#nav" className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem}>Subscribe</Link></li>
                    <li><Link to="/shop#nav" className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem}>Shop</Link></li>
                </ul>
            </nav>
        </header>
    )
};
export default Header;